import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../appUtils/axiosConfig";

const initialState = {

    isLoading: false,
    error: null,
    hsns: [],
    isHsnsLoading: false

}


export const getHsns = createAsyncThunk(
    'get_hsns_page',
    async (_, { dispatch, rejectWithValue }) => {

        try {
            dispatch(getHsnsStart());
            const response = await axios.get(`/hsn/get_hsn.php`)
            if (response?.status === 'success') {

                dispatch(getHsnsSuccess(response?.data?.data))
            }

            return response?.data?.data
        } catch (error) {
            dispatch(getHsnsFailure(error.response.data.message))
        }
    }
)
export const addHsn = createAsyncThunk(
    "addhsns",
    async (data, { dispatch, rejectWithValue }) => {
        try {
            dispatch(addHsnsStart());
            // Transform UI data to API format before sending
            const response = await axios.post(`/hsn/add_hsn.php`, data);
            dispatch(addHsnsSuccess(response.data?.user));
            if (response?.data?.status === 'success') {
                dispatch(getHsns())
                // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
            }
            return response.data
        } catch (error) {
            dispatch(addHsnsFailure(error.response.data.message));
            // SHOW_ERROR_NOTIFICATION(error.response.data.message);
            return rejectWithValue(error.response.data.message);
        }
    }
);
export const deleteHsn = createAsyncThunk('deletehsn', async (id, { dispatch, rejectWithValue }) => {
    try {
        dispatch(updateHsnsStart());
        const response = await axios.delete(`/hsns/delete_hsns.php?id=${id}`);
        if (response?.data?.status === 'success') {
            dispatch(getHsns())
            // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
        }
        return response.data
    } catch (error) {
        // SHOW_ERROR_NOTIFICATION(error.response.data.message);
        return rejectWithValue(error.response.data.message);
    }
})
export const updateHsn = createAsyncThunk(
    "hsn/updateHsn",
    async ({ id, data }, { dispatch, rejectWithValue }) => {
        console.log("Updating HSN — ID:", id, "Data:", data);

        try {
            dispatch(updateHsnsStart());

            // Send to API as expected (id + payload)
            const response = await axios.post(`/hsn/update_hsn.php`, {
                id,
                ...data,
            });

            if (response?.data?.status === "success") {
                dispatch(updateHsnsSuccess(response.data?.hsn));
                dispatch(getHsns()); // refresh list
            } else {
                dispatch(updateHsnsFailure(response.data.message));
                return rejectWithValue(response.data.message);
            }

            return response.data;
        } catch (error) {
            const msg = error?.response?.data?.message || "Failed to update HSN";
            dispatch(updateHsnsFailure(msg));
            return rejectWithValue(msg);
        }
    }
);

const hsnsSlice = createSlice({
    name: 'hsns',
    initialState,
    reducers: {
        getHsnsStart(state) {
            state.isLoading = true;
            state.error = null;
        },
        getHsnsSuccess(state, action) {

            state.hsns = action.payload;
            state.isLoading = false;
        },
        getHsnsFailure(state, action) {
            state.hsns = null;
            state.isLoading = false;
            state.error = action.payload;

        },
        addHsnsStart(state) {
            state.isHsnsLoading = true;
            state.error = null;
        },
        addHsnsSuccess(state, action) {
            state.user = action.payload;
            state.isHsnsLoading = false;
        },
        addHsnsFailure(state, action) {
            state.error = action.payload;
            state.isHsnsLoading = false;
        },

        updateHsnsStart(state) {
            state.isHsnsLoading = true;
            state.error = null;
        },
        updateHsnsSuccess(state, action) {
            state.user = action.payload;
            state.isHsnsLoading = false;
        },
        updateHsnsFailure(state, action) {
            state.error = action.payload;
            state.isHsnsLoading = false;
        },
    }
})

export const { getHsnsSuccess, getHsnsStart, getHsnsFailure, addHsnsStart, addHsnsSuccess, addHsnsFailure, updateHsnsStart, updateHsnsSuccess, updateHsnsFailure } = hsnsSlice.actions;

export default hsnsSlice.reducer;